import '../css/slider.css'


import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';


import 'swiper/css'
import '../css/slider.css'
import "swiper/css/effect-fade";
import 'swiper/swiper-bundle.css';

import uno from '../img/1.webp'
import dos from '../img/2.webp'
import tres from '../img/3.webp'
import cuatro from '../img/4.webp'



const Slider = () => {

  const texts = [
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div className='pi'>
        <p style={{ fontSize: '20px', color: '#fff' }}>La materia guarda la huella de lo vivido.
          Cada línea es un intento por traducir emociones, recuerdos y sensaciones que no encuentran 
          otra forma de decirse. En la repetición del gesto, en la presión sobre la plancha o el papel,
           aparecen las fisuras, lo irregular, lo humano. Allí se aloja el sentido profundo de esta práctica: 
           hacer visible lo invisible.</p></div>


      <img style={{ objectFit: 'cover', width: '100%', height: '100%', position: 'relative', zIndex: '20' }} src={uno} alt='grabado' />
    </div>,
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div className='pi'>
        <p style={{ fontSize: '20px', color: '#fff' }}>Las obras reunidas aquí surgen de la observación 
          insistente, casi obstinada, del mundo y de su memoria.
          Son gestos repetidos, resignificados, donde la precisión técnica convive con lo incierto. 
          Cada pieza puede ser una pausa, una pregunta, una grieta por donde asomarse a otra forma de mirar.</p></div>

      <img style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'relative', zIndex: '20' }} src={dos} alt='grabado' /></div>,
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div className='pi'>
        <p style={{ fontSize: '20px', color: '#fff' }}>El tiempo, invisible y constante, imprime en cada superficie 
          una historia única. Cada trazo es un eco de momentos pasados, 
          un diálogo silencioso entre el presente y lo que quedó atrás. En la combinación de luces y sombras 
          se revela una memoria que se resiste a desaparecer, invitándonos a detenernos y observar con atención. 
          La obra se transforma así en un espacio donde se entrelazan lo tangible y lo intangible, una invitación a 
          sentir lo que las palabras no alcanzan a decir.</p></div>

      <img style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'relative', zIndex: '20' }} src={tres} alt='grabado' /></div>,
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div className='pi'>
        <p style={{ fontSize: '20px', color: '#fff' }}>El arte es el lenguaje de lo profundo,
           donde las formas se disuelven y vuelven a surgir en un ciclo interminable de creación y 
           transformación. La búsqueda constante de significado aparece en cada detalle, en la textura 
           de la materia, en la presión que deja una huella imborrable. En ese gesto repetido se expresa
            la lucha por hacer visible lo que parece invisible, la voluntad de captar la esencia de lo efímero
             y convertirlo en algo que perdure. Así, cada pieza se convierte en un testimonio vivo del tiempo,
              del cuerpo y del alma que la habita.</p></div>

      <img style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'relative', zIndex: '20' }} src={cuatro} alt='grabado'/></div>

  ];


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', width: '100%' }}>


      <Swiper
       
        //slidesPerView={1}
        //spaceBetween={30}
        effect={'fade'}
        //croosFade = {true}
        // navigation ={true}
        loop={true}
        autoplay={{ delay: 10000 }}
        speed={2000}


        modules={[Autoplay, Pagination, EffectFade]}
      >

        {
          texts.map((text, index) => (
            <SwiperSlide key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{  zIndex: '20', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', left: '0%'}}>
                {text}
              </div>
            </SwiperSlide>
          ))
        }




      </Swiper>
    </div>
  )
}

export default Slider